import { Label } from '../../../components/forms/Input/Label'
import { ZonedDateTime } from '@internationalized/date'
import { DateTimePicker } from '../../../components/forms/DateTimePicker'
import * as styles from '../SignupShared.styles'
import { isMoreThanYearsAgo } from '../../../utilities/dateTimeUtils'

type Props = {
  initialDate: ZonedDateTime
  onChange: (date: ZonedDateTime) => void
}

export default function DateOfBirthInput({ initialDate, onChange }: Props) {
  return (
    <div>
      <Label text="Date of birth" iconClassName="fa fa-calendar" />
      <div css={styles.dateDropdownsContainer}>
        <DateTimePicker
          onChange={onChange}
          initialDateTime={initialDate}
          noTimePicker
          isDateUnavailable={(date) => isMoreThanYearsAgo(date, 16)}
        />
      </div>
    </div>
  )
}
